export default __webpack_public_path__ + "static/media/bar.fc4c1ab6.jpg";